import { analyticsAccordionItemOpen } from '../analytics/listeners/externallyTriggeredEvents';
import { isInView } from '../helpers/isInView';
import { scrollToElement } from '../helpers/scrollToElement';
import { eventKeyCodes } from '../helpers/eventKeyCodes';

export class Accordion {
  static isOnPage() {
    return $('.js-accordion').length !== 0;
  }

  constructor() {
    this.init();
    $('.js-accordion-content').hide();

    $('.js-accordion-toggle').each((idx, el) => {
      const $toggle = $(el);
      const labelValue = $toggle.attr('aria-label-value') || '';
      const parts = labelValue.split(' - ');

      const $item = $toggle.closest('.js-accordion-item');
      const $heading = $item.find('h2, h3, span').first();
      const headingText = $heading.text().trim();

      if (headingText && parts.length === 2) {
        $toggle.attr('aria-label', `${headingText} - ${parts[0]}`);
      }
    });
  }

  activateArrow($arrow) {
    $arrow.removeClass('icon-arrow-down').addClass('icon-arrow-up');
  }

  deactivateAllArrows($accordion) {
    $accordion.find('.js-accordion-arrow')
      .removeClass('icon-arrow-up')
      .addClass('icon-arrow-down');
  }

  activateItem(item) {
    const $item = $(item).parents('.js-accordion-item');
    const $toggle = $item.find('.js-accordion-toggle');

    this.deactivateAll($item.parents('.js-accordion'));
    $item
      .addClass('accordion-expanded')
      .removeClass('accordion-collapsed');

    $toggle.attr('aria-expanded', true);

    const labelValue = $toggle.attr('aria-label-value') || '';
    const parts = labelValue.split(' - ');

    const $heading = $item.find('h2, h3, span').first();
    const headingText = $heading.text().trim();

    if (headingText && parts.length === 2) {
      $toggle.attr('aria-label', `${headingText} - ${parts[1]}`);
    }

    this.activateArrow($item.find('.js-accordion-arrow'));
    $item.find('.js-accordion-content').slideDown(() => {
      if (!isInView(item)) {
        scrollToElement($item);
      }
      $toggle.trigger('focus');
    });

    analyticsAccordionItemOpen($toggle.text().trim());
  }

  deactivateAll($accordion) {
    $accordion.find('.js-accordion-item')
      .removeClass('accordion-expanded')
      .addClass('accordion-collapsed');

    $accordion.find('.js-accordion-toggle').each((idx, el) => {
      const $toggle = $(el);
      const labelValue = $toggle.attr('aria-label-value') || '';
      const parts = labelValue.split(' - ');

      $toggle.attr('aria-expanded', false);

      const $item = $toggle.closest('.js-accordion-item');
      const $heading = $item.find('h2, h3, span').first();
      const headingText = $heading.text().trim();

      if (headingText && parts.length === 2) {
        $toggle.attr('aria-label', `${headingText} - ${parts[0]}`);
      }
    });

    this.deactivateAllArrows($accordion);
    $accordion.find('.js-accordion-content').slideUp(() => {
      $accordion.find('.js-accordion-toggle').first().focus();
    });
  }

  onToggle(target) {
    if ($(target).parents('.js-accordion-item').hasClass('accordion-collapsed')) {
      this.activateItem(target);
    } else {
      this.deactivateAll($(target).parents('.js-accordion'));
    }
  }

  addEvents() {
    $('.js-accordion-toggle').on('click keydown', (event) => {
      if (event.type === 'click' || event.keyCode === eventKeyCodes.enter || event.keyCode === eventKeyCodes.space) {      
        event.preventDefault();
        
        if(!$(event.target).hasClass('js-info-panel-toggle')){
          this.onToggle(event.currentTarget);    
        }
      }
    });
  }

  init() {
    this.addEvents();
  }
}